import { Component, OnInit } from '@angular/core';
import { BehaviorSubject, Observable, Subject } from 'rxjs';
import { AuthenticationService } from '@app/core/services/authentication.service';
import { CheckoutService } from '@app/core/services/checkout.service';
import { Platform, ToastController } from '@ionic/angular';
import { Router } from '@angular/router';
import { OrderItemDTO } from 'ticket-sdk';
import { environment } from '@env';

@Component({
  selector: 'app-buy-ticket',
  templateUrl: './buy-ticket.page.html',
  styleUrls: ['./buy-ticket.page.scss'],
})
export class BuyTicketPage implements OnInit {
  isAuthenticated: Observable<boolean>;
  orderItems$: BehaviorSubject<OrderItemDTO[]>;

  constructor(
    private authenticationService: AuthenticationService, 
    private checkoutService: CheckoutService,
    public platform: Platform,
    private router: Router,
    public toastController: ToastController,
  ) { }

  get isMobile() {
    return this.platform.is('mobile');
  }

  get isProd(): boolean {
    return environment.production;
  }

  goToCheckout() {
    this.router.navigate(['checkout']);
  }

  ngOnInit() {
    this.isAuthenticated = this.authenticationService.authenticationState;

    this.orderItems$ = this.checkoutService.getSimpleOrderItems();
  }

  ionViewWillEnter() {
    this.checkoutService.checkIfOrderItemsExpired();
  }

  async presentFetchDataErrorToast() {
    const toast = await this.toastController.create({
      message: 'Ett okänt fel uppstod. Prova igen om en liten stund',
      color: 'danger',
      position: 'top',
      duration: 5000
    });
    toast.present();
  }
}
